module.exports = __webpack_public_path__ + "static/kv-143b74ab53cbe5e0766d99a2dc74dc27.png";